export const THIRDPARTY_POST_RF = 'thirdparty_post_rf';
export const AUTH_CALL_LK = 'auth_call_lk';
export const AUTH_CALL_MODAL = 'auth_call_modal';
export const AUTH_CALL_BASKET = 'auth_call_basket';
export const CART_NEW_PROMO = 'cart_new_promo';
export const ABTEST_FUNDAY_TEST_G1 = 'abtest_funday_test_g1';
export const DELIVERY_STORAGE_EXTENSION = 'delivery_storage_extension';
export const EXPRESS_DELIVERY = 'express_delivery';
export const EXPRESS_DELIVERY_FILTER = 'express_delivery_filter';
export const OFFLINE_ORDER_RECEIPTS = 'offline_order_receipts';
export const SCROLLABLE_HEADER_DESKTOP = 'scrollable_header_desktop';
export const SCROLLABLE_HEADER_TABLET = 'scrollable_header_tablet';
export const SCROLLABLE_HEADER_MOBILE = 'scrollable_header_mobile';
export const NOTIFICATION_ADD_TO_CART_FREE_SHIPPING_LIMIT_NOT_EXCEEDED_KT = 'notification_add_to_cart_free_shipping_limit_not_exceeded_kt';
export const NOTIFICATION_ADD_TO_CART_FREE_SHIPPING_LIMIT_NOT_EXCEEDED_CART = 'notification_add_to_cart_free_shipping_limit_not_exceeded_cart';
export const NOTIFICATION_ADD_TO_CART_FREE_SHIPPING_LIMIT_EXCEEDED_KT = 'notification_add_to_cart_free_shipping_limit_exceeded_kt';
export const NOTIFICATION_ADD_TO_CART_FREE_SHIPPING_LIMIT_EXCEEDED_CART = 'notification_add_to_cart_free_shipping_limit_exceeded_cart';
export const NOTIFICATION_WIDGET = 'notification_widget';
export const DEFAULT_FILTER_DELIVERY_OFF = 'default_filter_delivery_off';
export const GOOGLE_RECAPTCHA_ON = 'google_recaptcha_on';
export const NOTIFICATION_CHOOSE_ONE_WAY_FREE_SHIPPING_LIMIT_EXCEEDED_CART = 'notification_choose_one_way_free_shipping_limit_exceeded_cart';
export const NEW_SIZE_BUTTONS_COLOUR = 'new_size_buttons_colour';
export const ADD_PRODUCT_FROM_CATALOG_DESKTOP = 'add_product_from_catalog_desktop';
export const ADD_PRODUCT_FROM_CATALOG_TABLET = 'add_product_from_catalog_tablet';
export const ADD_PRODUCT_FROM_CATALOG_MOBILE = 'add_product_from_catalog_mobile';
export const ONLINE_CHAT = 'online_chat';
export const QUESTIONS_ENABLED = 'questions_enabled';
export const PROMO_KITS_ENABLED = 'promo_kits_enabled';
export const CERTIFICATE_MINTSIFRY = 'certificate_mintsifry';
export const CTA_CART_PRODUCT = 'cta_cart_product';
export const PHOTO_ZOOM = 'photo_zoom';
export const BARKODE_SCANER = 'barcode_scaner';
export const TIMER_ON_CART = 'timer_on_cart';
export const PREDICTIVE_INPUT = 'predictive_input';
export const FUNDAY_REDIRECT = 'funday_redirect';
export const TIMER_ON_PRODUCT = 'timer_on_product';
export const PRODUCT_PERSONAL_PRICE = 'personal_price';
export const PHOTOS_IN_REVIEWS = 'photos_in_reviews';
export const PROMO_MP_POPUP = 'promo_mp_popup';
export const REVIEWS_POPUP_ON_MAIN_PAGE = 'reviews_popup_on_main_page';
export const ADD_PRODUCT_FROM_SLIDER_WITH_TIMER = 'add_product_from_slider_with_timer';
export const STORAGE_PERIOD_COMMUNICATION = 'storage_period_communication';
export const BARCODE_SCANNER = 'barcode_scanner';
export const ACTIVE_ORDERS_WIDGET = 'active_orders_widget';
export const REC_MAIN_FAVORITES = 'rec_main_favorites';
export const REC_PRODUCT = 'rec_product';
export const REC_FAV_VIEWED = 'rec_fav_viewed';
export const REC_ADDRESSES_VIEWED = 'rec_addresses_viewed';
export const SEO_TAGS_ON_PRODUCT_CARD = 'seo_tags_on_product_card';
export const SEO_TAGS_IN_CATALOG = 'seo_tags_in_catalog';
export const BNPL = 'bnpl';
export const BNPL_PRODUCT_CARD = 'bnpl_product_card';
export const NOTIFICATIONS_ACTIONS = 'notifications_actions';
export const NOTIFICATIONS_PROMOCODES = 'notifications_promocodes';
export const NOTIFICATIONS_ORDERS = 'notifications_orders';
export const NOTIFICATIONS_MESSAGES = 'notifications_messages';
export const NOTIFICATIONS_BONUSES = 'notifications_bonuses';
export const PRODUCT_PICK_UP = 'product_pick_up';
export const CONTENT_LANDING_PAGES = 'content_landing_pages';
export const REGISTRATION_POP_UP = 'registration_pop_up';
export const ADD_PREVIEW_PRODUCT = 'add_preview_product';

export default {
  THIRDPARTY_POST_RF,
  AUTH_CALL_LK,
  AUTH_CALL_MODAL,
  AUTH_CALL_BASKET,
  CART_NEW_PROMO,
  ABTEST_FUNDAY_TEST_G1,
  DELIVERY_STORAGE_EXTENSION,
  EXPRESS_DELIVERY,
  EXPRESS_DELIVERY_FILTER,
  OFFLINE_ORDER_RECEIPTS,
  SCROLLABLE_HEADER_DESKTOP,
  SCROLLABLE_HEADER_TABLET,
  SCROLLABLE_HEADER_MOBILE,
  NOTIFICATION_ADD_TO_CART_FREE_SHIPPING_LIMIT_NOT_EXCEEDED_KT,
  NOTIFICATION_ADD_TO_CART_FREE_SHIPPING_LIMIT_NOT_EXCEEDED_CART,
  NOTIFICATION_ADD_TO_CART_FREE_SHIPPING_LIMIT_EXCEEDED_KT,
  NOTIFICATION_ADD_TO_CART_FREE_SHIPPING_LIMIT_EXCEEDED_CART,
  NOTIFICATION_WIDGET,
  DEFAULT_FILTER_DELIVERY_OFF,
  GOOGLE_RECAPTCHA_ON,
  NOTIFICATION_CHOOSE_ONE_WAY_FREE_SHIPPING_LIMIT_EXCEEDED_CART,
  NEW_SIZE_BUTTONS_COLOUR,
  ADD_PRODUCT_FROM_CATALOG_DESKTOP,
  ADD_PRODUCT_FROM_CATALOG_TABLET,
  ADD_PRODUCT_FROM_CATALOG_MOBILE,
  ONLINE_CHAT,
  QUESTIONS_ENABLED,
  PROMO_KITS_ENABLED,
  CERTIFICATE_MINTSIFRY,
  CTA_CART_PRODUCT,
  PHOTO_ZOOM,
  PROMO_MP_POPUP,
  BARKODE_SCANER,
  TIMER_ON_CART,
  PREDICTIVE_INPUT,
  FUNDAY_REDIRECT,
  TIMER_ON_PRODUCT,
  PHOTOS_IN_REVIEWS,
  REVIEWS_POPUP_ON_MAIN_PAGE,
  ADD_PRODUCT_FROM_SLIDER_WITH_TIMER,
  STORAGE_PERIOD_COMMUNICATION,
  BARCODE_SCANNER,
  ACTIVE_ORDERS_WIDGET,
  REC_MAIN_FAVORITES,
  REC_PRODUCT,
  REC_FAV_VIEWED,
  REC_ADDRESSES_VIEWED,
  PRODUCT_PERSONAL_PRICE,
  BNPL_PRODUCT_CARD,
  BNPL,
  SEO_TAGS_ON_PRODUCT_CARD,
  SEO_TAGS_IN_CATALOG,
  NOTIFICATIONS_ACTIONS,
  NOTIFICATIONS_PROMOCODES,
  NOTIFICATIONS_ORDERS,
  NOTIFICATIONS_MESSAGES,
  NOTIFICATIONS_BONUSES,
  PRODUCT_PICK_UP,
  CONTENT_LANDING_PAGES,
  REGISTRATION_POP_UP,
  ADD_PREVIEW_PRODUCT,
} as const;
